import Splide from "@splidejs/splide";

const lockSlider = () => {
  if (!document.getElementById("lock-slider")) {
    return;
  }
  let slider = new Splide("#lock-slider", {
    type: "slide",
    arrows: false,
    pagination: false,
    perPage: "auto",
    direction: "ttb",
    height: "56.4rem",
    gap: "2rem",
    trimSpace: false,
    waitForTransition: true,
    easing: "linear",
    releaseWheel: true,
    focus: "center",
    drag: true,
    snap: true,
    wheel: true,
    perMove: 1,
    wheelSleep: 1000,
    flickMaxPages: 1,
    breakpoints: {
      991: {
        trimSpace: true,
        direction: "ltr",
        height: "auto",
      },
    },
  });

  const images = document.querySelectorAll(".js-lock-image");

  var bar = slider.root.querySelector(".lock-slider-progress-bar");
  var barLine = slider.root
    .querySelector(".lock-slider-progress")
    .getBoundingClientRect().height;
  let barLineWidth = slider.root
    .querySelector(".lock-slider-progress")
    .getBoundingClientRect().width;
  slider.on("mounted", () => {
    if (window.innerWidth > 991) {
      bar.style.height = barLine / slider.length + "px";
    } else {
      bar.style.width = barLineWidth / slider.length + "px";
    }
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 991) {
      barLine = slider.root
        .querySelector(".lock-slider-progress")
        .getBoundingClientRect().height;
      bar.style.height = barLine / slider.length + "px";
      bar.style.width = "0.8rem";
    } else {
      barLineWidth = slider.root
        .querySelector(".lock-slider-progress")
        .getBoundingClientRect().width;
      bar.style.height = "0.8rem";
      bar.style.width = barLineWidth / slider.length + "px";
    }
  });

  // Updates the bar width whenever the carousel moves:
  slider.on("mounted move", function () {
    if (window.innerWidth > 991) {
      bar.style.transform =
        "translateY(" + String(100 * slider.index) + "%" + ")";
    } else {
      bar.style.transform =
        "translateX(" + String(100 * slider.index) + "%" + ")";
    }
    images.forEach((image) => {
      image.classList.remove("active");
      images[slider.index].classList.add("active");
    });
  });
  slider.mount();
};

export default lockSlider;
